import { useAuth } from "@stardeck-customer-apps/project-auth";
import { Car, LogIn, Repeat } from "lucide-react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button } from "@/components/button";
import { Card, CardContent } from "@/components/card";

export function AdminLogin() {
  const { isAuthenticated, isLoading, signIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate("/");
    }
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white p-4">
        <div className="mx-auto max-w-md">
          <Link
            to="/cars"
            className="inline-flex items-center gap-2 text-sm text-slate-500 transition-colors hover:text-indigo-600"
          >
            <Car className="size-4" />
            กลับหน้าแสดงรถ
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex flex-1 items-center justify-center p-4">
        <Card className="w-full max-w-md overflow-hidden rounded-2xl border-slate-200 shadow-lg">
          <div className="bg-gradient-to-br from-indigo-500 to-indigo-600 px-6 py-10 text-center">
            <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-2xl bg-white/10 shadow-lg shadow-indigo-600/20 backdrop-blur-sm">
              <Repeat className="size-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-white">General Auto Cars</h1>
            <p className="mt-1 text-sm text-indigo-100">ระบบจัดการ CRM</p>
          </div>
          <CardContent className="p-6">
            <div className="space-y-6">
              <div className="text-center">
                <h2 className="text-xl font-bold text-slate-900">เข้าสู่ระบบผู้ดูแล</h2>
                <p className="mt-2 text-sm text-slate-500">
                  เข้าสู่ระบบเพื่อจัดการลูกค้า รถยนต์ และการขาย
                </p>
              </div>

              {isLoading ? (
                <div className="flex justify-center py-4">
                  <div className="size-8 animate-spin rounded-full border-4 border-indigo-500 border-t-transparent" />
                </div>
              ) : (
                <Button
                  className="w-full rounded-xl bg-indigo-500 py-6 text-base hover:bg-indigo-600"
                  size="lg"
                  onClick={() => signIn("/")}
                >
                  <LogIn className="mr-2 size-5" />
                  เข้าสู่ระบบด้วย Stardeck
                </Button>
              )}

              <div className="border-t border-slate-200 pt-4 text-center">
                <p className="text-xs text-slate-400">เฉพาะผู้ดูแลระบบที่ได้รับอนุญาตเท่านั้น</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white p-4 text-center text-sm text-slate-400">
        © {new Date().getFullYear()} General Auto Cars
      </footer>
    </div>
  );
}
